import { useTranslation } from 'react-i18next';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { useNotification } from '@/js/libs/ui/src/V2';

import { useAppLogout } from './useAppLogout/index.ts';

type ForcedLogoutHandler = () => void;

const UNAUTHORIZED_TOAST_ID = 'unauthorized';

export const useForcedLogout = () => {
  const [t] = useTranslation(['messages']);
  const notify = useNotification();
  const logout = useAppLogout();

  const handleForcedLogout = useCallbackRef<ForcedLogoutHandler>(() => {
    logout();
    notify.error({
      body: t('messages:LOGGED_OUT_NOTICE'),
      toastId: UNAUTHORIZED_TOAST_ID,
    });
  });

  return handleForcedLogout;
};
